/* Norse Quiz Timeline — scroll reveal. Only loaded when the section's "Animate on scroll"
   setting is on. CSS holds the hidden start state and every animation; this only arms the
   section and reveals it once it scrolls into view. */
(function () {
  if (window.__nqtAnimateInit) return;
  window.__nqtAnimateInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function arm(root) {
    if (root.hasAttribute('data-nqt-armed') || reduced) return;
    root.setAttribute('data-nqt-armed', '');
    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        observer.disconnect();
        root.classList.add('is-visible');
      },
      { threshold: 0.3 }
    );
    observer.observe(root);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.nqt--animate').forEach(arm);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
